import {Component, Input, OnChanges, SimpleChanges, OnInit} from '@angular/core';
import { GadgetApiService, GadgetsService } from '@signature-it/ngx-generic/services';
import { RestUrlsConfig, GenericConfig } from '@signature-it/ngx-generic/config';
import {GadgetFilterDTO} from '@signature-it/ngx-generic/models';

declare let _: any;

@Component({
    selector: 'multiple-bars-rest-api-gadget',
    templateUrl: './multiple-bars.gadget.html',
    styleUrls: ['./multiple-bars.gadget.scss'],
    standalone: false
})
export class MultipleBarsRestApiGadget implements OnInit  {

    @Input() title: string;
    @Input() dataCount: number;
    @Input() url;
    @Input() filterName: string;
    @Input() dataConfig: object;
    @Input() byFilters: boolean = true;
    @Input() key: string;
    @Input() type: string;
    percent: number = 0;
    data;
    filters;
    serverSideFilter;
    gadgetFilterSubscription;
    qtyFilters: number = 0;
    loader: boolean = false;
    print: boolean = false;
    open = false;

    constructor(protected gadgetApiSvc: GadgetApiService,
                protected gadgetSvc: GadgetsService) {

    }

    ngOnInit(){
        this.type = this.type || 'MuiltipleBar';
        this.key = this.key || 'muiltiple-bar-gadget';
        let gadgetConfig = GenericConfig.gadgets.find(x => x.type === this.type && x.key === this.key);
        if (gadgetConfig) {
            this.url = this.url || gadgetConfig.url;
            this.title = this.title || gadgetConfig.title;
            this.dataConfig = this.dataConfig || gadgetConfig.data;
            this.filterName = this.filterName || 'MultipleBars';
            let qtyFilters = GenericConfig.filterGadget.filter(x => x.name === this.filterName && x.serverSide );
            if (qtyFilters) {
                this.qtyFilters = qtyFilters.length;
            }
            this.setFilters();
        }

    }

    // ngOnChanges(changes: SimpleChanges): void {
    //
    //     if (_.has(changes, 'data.currentValue')) {
    //         if (_.has(changes.data.currentValue, 'statistics_info.statistics')) {
    //             this.data['statistics_info'].statistics = _.keyBy(changes.data.currentValue.statistics_info.statistics, 'val');
    //         }
    //     }
    // }

    setFilters() {
        this.gadgetFilterSubscription = this.gadgetSvc.gadgetFilter.subscribe(gadgetFilter => {
            let serverSideFilter = _.filter(gadgetFilter, (filter: any) => filter.name === this.filterName && filter.serverSide);
            if (serverSideFilter) {
                if (!this.serverSideFilter || this.gadgetSvc.compareVal(serverSideFilter, this.serverSideFilter)) {
                    this.serverSideFilter = [];
                    serverSideFilter.forEach(dataFilter => {
                        this.serverSideFilter.push(new GadgetFilterDTO(dataFilter))
                    });
                    if (this.gadgetSvc.hasParams(this.serverSideFilter) && this.serverSideFilter.length == this.qtyFilters) {
                        this.getData();
                    }
                }
                let filters = _.find(gadgetFilter, (filter: any) => filter.name === this.filterName && !filter.serverSide);
                if (filters != this.filters) {
                    this.filters = _.cloneDeep(filters);
                    this.setDataCount();
                }
            }
        });
    }



    getData() {
        this.loader = true;
        let params = this.gadgetSvc.setParams(this.serverSideFilter, this.dataConfig);
        this.gadgetApiSvc.getGadgetData(params , this.url)
            .subscribe(
                res => {
                    this.loader = false;
                    this.data =  _.chain(res)
                        .groupBy( data => data[0])
                        .mapValues((values) => ({
                                'value': _.orderBy(values, [2],['asc']),
                                'count': _.chain(values)
                                    .sumBy((val) => parseInt(val[2]))
                                    .value()
                            })
                        ).value();
                    this.setDataCount();
                }
            )
    }

    setDataCount() {
        this.dataCount = 0;
        if(this.data && this.filters.value && _.has(this.data[this.filters.value], 'count')) {
            this.dataCount = this.data[this.filters.value].count || 0;
        }
    }

    setStyle(data) {
        let calc = data/this.dataCount*100;
        calc = (calc < 8) ? 8 : calc;
        return {width: calc + '%' } ;
    }

    onPrintNotify() {
        this.print = !this.print;
    }
}
